import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

export type GetAssetBalanceResponse = {
  balance: number;
  balanceInValueAsset: number;
  buyRate: number;
  sellRate: number;
};

export type GetAssetBalanceResp = {
  getAssetBalance: DefaultApiResponse<GetAssetBalanceResponse>;
};

export type GetAssetBalanceArgs = {
  valueAssetCode: string;
  assetCode: string;
};

export const getAssetBalance: TypedDocumentNode<
  GetAssetBalanceResp,
  DefaultArg<GetAssetBalanceArgs>
> = gql`
  query GetAssetBalance($record: GetBalanceRecord!) {
    getAssetBalance(record: $record) {
      balance
      balanceInValueAsset
      buyRate
      sellRate
    }
  }
`;
